import {cn} from '@/lib/utils';
import {Icon} from '../Icon';
export interface CheckListItem {
  checked: boolean;
  label: string;
}
export interface CheckListProps {
  className?: string;
  items: CheckListItem[];
  style?: React.CSSProperties;
}
export const CheckList = ({className, items, style}: CheckListProps) => {
  return (
    <div className={cn('flex flex-col gap-1', className)} style={style}>
      {items.map((item, index) => {
        const colorClassName = item.checked ? 'text-green-600' : '';
        return (
          <div className={'flex items-center gap-2'} key={index}>
            <Icon className={colorClassName} icon={item.checked ? 'check-square' : 'stop'} />
            <span className={colorClassName}>{item.label}</span>
          </div>
        );
      })}
    </div>
  );
};
